module.exports = __webpack_public_path__ + "img/AGR-A-3-I.35f370f0.png";